import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from '@hydra/common/components';
import { getGridSizeObject } from '../../utils/columnSizes';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  row: {
    padding: theme.spacing(0.5, 2),
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    flexDirection: 'column',
    [(theme.breakpoints.up('sm'))]: {
      flexDirection: 'row'
    }
  },
  noResult: {
    margin: theme.spacing(4)
  }
}));

export const CrawlerBody = props => {
  const classes = useStyles();
  const { nodes, columns } = props;
  const hasResults = (nodes.length && nodes.length >= 0);
  const columnStyles = (columns && columns.length) ? columns.map(getGridSizeObject) : [];

  const noResult = (
    <div className={classes.noResult}>
      <Translate content='crawler_no_issues_detected' />
    </div>
  );

  const content = (
    <div {...props}>
      {
        nodes.map(node =>
          <props.component
            className={classes.row}
            key={node.id}
            issue={node}
            columnStyles={columnStyles}
          />
        )
      }
    </div>
  );

  return (
    hasResults
      ? content
      : noResult
  );
};

CrawlerBody.propTypes = {
  columns: PropTypes.array,
  // see https://github.com/facebook/react/issues/3077
  component: PropTypes.any,
  nodes: PropTypes.array,
  host: PropTypes.string
};

export default CrawlerBody;
